import { Modal } from "react-bootstrap";
import React from "react";
import { useIntl } from "react-intl";

const AvailableDialog = ({
  available,
  setAvailable,
  dialogAva,
  setDialogAva,
  formik,
  type,
}) => {
  const intl = useIntl();
  const handleChange = () => {
    setAvailable(available ? false : true);
    formik.setFieldValue("is_available", available ? 0 : 1);
    setDialogAva(false);
  };
  return (
    <Modal show={dialogAva} aria-labelledby="example-modal-sizes-title-lg">
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">
          {available
            ? intl.formatMessage({ id: "Unavailable" })
            : intl.formatMessage({ id: "Available" })}{" "}
          User
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <span>
          {intl.formatMessage({ id: "Are.you.sure" })}{" "}
          {available
            ? intl.formatMessage({ id: "unavailable" })
            : intl.formatMessage({ id: "available" })}{" "}
          {intl.formatMessage({ id: "this.user" })}{" "}
        </span>
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            type="button"
            onClick={() => setDialogAva(false)}
            className="btn btn-light btn-elevate"
          >
            {intl.formatMessage({ id: "No" })}
          </button>
          <> </>
          <button
            type="button"
            onClick={handleChange}
            className="btn btn-delete btn-elevate"
          >
            {intl.formatMessage({ id: "Yes" })}
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default AvailableDialog;
